import { GET_ORDERS, TRACK_ORDER } from "../constant/user";

const initialState = {
  orderDetails: {},
  orders: [],
};

const OrderDeatailReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TRACK_ORDER:
      return { ...state, orderDetails: payload };
    case GET_ORDERS:
      return { ...state, orders: payload };
    default:
      return state;
  }
};

export default OrderDeatailReducer;
